function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.88 12.28v7.12H20.44v12.16h-8.88V19.4H.12v-7.12h11.44V.12h8.88v12.16z",
  fill: "currentColor"
});

function SvgIconPlus(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTUwLjg4IDM2LjI4djcuMTJoLTExLjQ0djEyLjE2aC04Ljg4di0xMi4xNmgtMTEuNDR2LTcuMTJoMTEuNDR2LTEyLjE2aDguODh2MTIuMTZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOSAtMjQpIi8+PC9zdmc+Cg==";
export { SvgIconPlus as ReactComponent };